function pushToDataLayer(payload) {
  if (typeof window.dataLayer !== 'undefined') {
    window.dataLayer.push(payload);
  }
}

// takes form data and returns all it's data in following format:
// sortby: newest | fuel: hydrogen, electric | product-category: large-excavators, site-dumpsters
function determineSelectedFilters(formEl) {
  const fd = new FormData(formEl);
  const formDataObject = formDataToObject(fd);
  let selectedFiltersArr = [];
  for (const [key, value] of Object.entries(formDataObject)) {
    key !== 'search' &&
      selectedFiltersArr.push(`${key}: ${Array.isArray(value) ? value.join(', ') : value}`);
  }
  return selectedFiltersArr.join(' | ');
}

function formDataToObject(formData) {
  const normalizeValues = (values) => (values.length > 1 ? values : values[0]);
  const formElemKeys = Array.from(formData.keys());

  return Object.fromEntries(
    formElemKeys.map((key) => [key, normalizeValues(formData.getAll(key))]),
  );
}

export { pushToDataLayer, determineSelectedFilters };
